<dynamic-form
  *ngIf="formGroup !== undefined"
  [apiName]="apiName"
  [group]="formGroup"
  [label]="label"
  [areaName]="areaName"
  [model]="model"
  [isShowModal]="false"
  [showCloseBtn]="false"
  [columns]="orignalColumns"
  (cancelChange)="cancel()"
  [noSubmit]="true">
  <ng-container class="content">
    <div class="inputs">
      <ssg-select
        class="column"
        name="VoucherKindId"
        apiName="InvVoucherKind/ReadInvVoucherKindLookUp"
        [group]="formGroup"
        label="نوع سند"
        textFieldName="Title"
        valueFieldName="Id"
        [required]="true"
        (valueChange)="onRowSelected($event)">
      </ssg-select>
      <ssg-select
        class="column"
        name="ReferenceVoucherKindIds"
        [group]="formGroup"
        [multiple]="true"
        label="نوع سند معطوف"
        [dataList]="ReferenceVoucherKind"
        textFieldName="Title"
        (valueChange)="onChange($event)"
        valueFieldName="Id">
      </ssg-select>
      <ssg-checkbox class="column" [group]="formGroup" (valueChange)="onChange($event)" name="ShowReference" label="نمایش اسناد با سند معطوف">
      </ssg-checkbox>
      <ssg-checkbox class="column" [group]="formGroup" (valueChange)="onChange($event)" name="LinearReferenced" label="معطوف سطری"> </ssg-checkbox>
    </div>

    <kgrid
      *ngIf="columns && columns.length > 0"
      #grid
      [apiName]="apiName"
      [areaName]="areaName"
      [label]="label"
      [filtering]="false"
      [allowUnsort]="false"
      [groupable]="false"
      [name]="apiName"
      [columns]="columns"
      [isEdit]="false"
      [isAdd]="false"
      (onRowSelected)="onRow_Selected($event)"
      [isDelete]="false"
      pathPreFix="INV">
    </kgrid>
  </ng-container>
  <ng-container class="footer">
    <ssg-button class="action-btn" icon="fa fa-filter" buttontype="button" (click)="Reference()" label="سند مبنا" size="medium">
    </ssg-button>
    <ssg-button class="action-btn" icon="fa fa-filter" buttontype="button" (click)="ReferenceTo()" label="سند معطوف" size="medium">
    </ssg-button>
  </ng-container>
</dynamic-form>
